module.exports = "query PartnersNearby ($lat: String!, $lng: String!) {\n  partnersNearby (latitude: $lat, longitude: $lng) {\n    name\n    slug\n    logo\n    logo_negative\n    distance\n    colors {\n      primary\n    }\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/PartnersNearby.graphql
// module id = 2012
// module chunks = 1612